import { gql } from 'apollo-angular';

export const EMAIL_NOTIFICATION_MUTATION = gql`
  mutation PostEmailNotificationPreferences(
    $emailNotificationPreferences: [EmailNotificationPrefrenceRequestInput!]!
  ) {
    PostEmailNotificationPreferences(
      emailNotificationPreferences: $emailNotificationPreferences
    ) {
      data
      isSuccess
      message
      errorCode
    }
  }
`;
